module.exports = __webpack_public_path__ + "static/media/sneakers.f94fb92a.jpg";